import {FC, ReactElement} from 'react';
import {
  PageTitleBlockWrapper,
  PageTitleWrapper,
  PageTitleButtonsWrapper,
  PageTitleRowWrapper,
  PageTitleBackBtnWrapper,
} from '@organisms/PageTitleBlock.styles';
import Text from '@atoms/Text';
import {ArrowLeft} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import {ISystem} from '@types';
import PageTitleDropdownBtn from '@atoms/PageTitleDropdownBtn';
import {useNavigate} from 'react-router';

export interface PageTitleBlockProps {
  title?: string;
  buttons?: ReactElement[];
  withBackBtn?: boolean;
  backBtnText?: string;
  backBtnLink?: string;
  systems?: ISystem[];
}

const PageTitleBlock: FC<PageTitleBlockProps> = ({
  title,
  buttons,
  withBackBtn = false,
  backBtnText = '',
  backBtnLink = '#',
  systems = [],
}) => {
  const navigate = useNavigate();
  return (
    <PageTitleBlockWrapper>
      {withBackBtn && (
        <PageTitleBackBtnWrapper onClick={() => navigate(backBtnLink)}>
          <ArrowLeft size={15} fill={theme.colors.accent00} />
          <Text text={backBtnText} type="tinyM" color={theme.colors.accent00} />
        </PageTitleBackBtnWrapper>
      )}
      <PageTitleRowWrapper>
        <PageTitleWrapper>
          {title && <Text text={title} type="headline" />}
          {!!systems.length && <PageTitleDropdownBtn systems={systems} />}
        </PageTitleWrapper>
        <PageTitleButtonsWrapper>
          {!!buttons?.length &&
            buttons.map(button => {
              return button;
            })}
        </PageTitleButtonsWrapper>
      </PageTitleRowWrapper>
    </PageTitleBlockWrapper>
  );
};

export default PageTitleBlock;
